import React from 'react'

const svgProps = { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 24 24', height: '24', width: '24' }

// remake
const IcoAddOut = () => (
  <svg {...svgProps}>
    <path d='M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' />
  </svg>
)
const IcoArrDown = () => (
  <svg {...svgProps}>
    <path d='M7 10l5 5 5-5z' />
  </svg>
)
// remake
const IcoArrows = () => (
  <svg {...svgProps}>
    <path d='M5.75 8.182a3 3 0 000 3.636l1.84 2.415c.76.998.05 2.434-1.205 2.434-.472 0-.918-.221-1.205-.597l-3.24-4.252a3 3 0 010-3.636L5.18 3.93a1.515 1.515 0 011.205-.597c1.254 0 1.965 1.436 1.206 2.434L5.75 8.182zM15.75 8.182a3 3 0 000 3.636l1.84 2.415c.76.998.05 2.434-1.205 2.434-.472 0-.918-.221-1.205-.597l-3.24-4.252a3 3 0 010-3.636l3.24-4.252a1.515 1.515 0 011.205-.597c1.254 0 1.965 1.436 1.206 2.434l-1.84 2.415z' />
  </svg>
)
// remake
function IcoApartment() {
  return (
    <svg {...svgProps}>
      <path d='M17,11V3H7v4H3v14h8v-4h2v4h8V11H17z M7,19H5v-2h2V19z M7,15H5v-2h2V15z M7,11H5V9h2V11z M11,15H9v-2h2V15z M11,11H9V9h2 V11z M11,7H9V5h2V7z M15,15h-2v-2h2V15z M15,11h-2V9h2V11z M15,7h-2V5h2V7z M19,19h-2v-2h2V19z M19,15h-2v-2h2V15z' />
    </svg>
  )
}
const IcoBackUp = () => (
  <svg {...svgProps}>
    <path d='M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z' />
  </svg>
)
const IcoClose = () => (
  <svg {...svgProps}>
    <path d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' />
  </svg>
)

const IcoCheck = () => (
  <svg {...svgProps}>
    <path d='M23.4142 6.58991L10.3089 20.3839C9.93332 20.7792 9.42589 21 8.89649 21C8.36709 21 7.85766 20.7792 7.48408 20.3839L0.585841 13.1231C-0.19528 12.301 -0.19528 10.972 0.585841 10.1498C1.36696 9.32768 2.62954 9.32768 3.41066 10.1498L8.89649 15.924L20.5893 3.61663C21.3705 2.79446 22.633 2.79446 23.4142 3.61663C24.1953 4.4388 24.1953 5.76773 23.4142 6.58991Z' />
  </svg>
)
// remake
const IcoDescription = () => (
  <svg {...svgProps}>
    <path d='M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z' />
  </svg>
)
const IcoDocument = () => (
  <svg {...svgProps}>
    <path
      fillRule='evenodd'
      d='M2 4C2 1.79086 3.79086 0 6 0H18C20.2091 0 22 1.79086 22 4V20C22 22.2091 20.2091 24 18 24H6C3.79086 24 2 22.2091 2 20V4ZM19 10L5 10L5 8L19 8V10ZM5 6L19 6V4L5 4L5 6ZM19 14L5 14L5 12L19 12V14ZM5 18H13.5817C14.2857 17 15 16 15 16L5 16L5 18Z'
    />
  </svg>
)
// remake
const IcoError = () => (
  <svg {...svgProps}>
    <path d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z' />
  </svg>
)
// remake
const IcoFolderOut = () => (
  <svg {...svgProps}>
    <path d='M9.17 6l2 2H20v10H4V6h5.17M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z' />
  </svg>
)
// remake
const IcoLanguages = () => (
  <svg {...svgProps}>
    <path d='M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z' />
  </svg>
)
const IcoKey = () => (
  <svg {...svgProps}>
    <path d='M8.97903 8.00765C6.69956 8.15234 4.95126 10.3164 5.40579 12.7826C5.6958 14.357 6.93028 15.6274 8.46144 15.9257C10.5433 16.3316 12.4 15.0283 12.9462 13.1431H15.3334V13.7146C15.3334 14.346 15.8306 14.8575 16.4445 14.8575C17.0584 14.8575 17.5557 14.346 17.5557 13.7146V13.1431C18.1696 13.1431 18.6668 12.6316 18.6668 12.0002C18.6668 11.3687 18.1696 10.8572 17.5557 10.8572H12.944C12.5441 9.45324 11.3941 8.34959 9.98275 8.07462C9.64031 8.00783 9.30467 7.98698 8.97903 8.00765ZM9.2221 10.2857C10.1427 10.2857 10.8888 11.0532 10.8888 12.0002C10.8888 12.9471 10.1427 13.7146 9.2221 13.7146C8.30151 13.7146 7.55538 12.9471 7.55538 12.0002C7.55538 11.0532 8.30151 10.2857 9.2221 10.2857Z' />
    <path
      fillRule='evenodd'
      d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
    />
  </svg>
)
const IcoLogout = () => (
  <svg {...svgProps}>
    <path d='M18.6343 6.64267C19.0574 6.28767 19.6882 6.34285 20.0432 6.76593L23.7517 11.1856C23.9023 11.365 23.9791 11.5819 23.9853 11.7992C24.036 12.0812 23.9658 12.3829 23.7672 12.6196L20.0753 17.0194C19.7203 17.4425 19.0895 17.4977 18.6664 17.1427C18.2434 16.7877 18.1882 16.1569 18.5432 15.7338L20.8372 12.9999H11C10.4477 12.9999 10 12.5522 10 11.9999C10 11.4476 10.4477 10.9999 11 10.9999H20.9851L18.5111 8.0515C18.1561 7.62843 18.2113 6.99767 18.6343 6.64267Z' />
    <path d='M10.9512 3C6.0122 3 2 7.02482 2 12C2 16.9752 6.0122 21 10.9512 21C12.3528 21 13.6765 20.6768 14.8554 20.1014C15.3517 19.8591 15.9504 20.065 16.1927 20.5613C16.435 21.0576 16.2291 21.6563 15.7328 21.8986C14.2869 22.6045 12.6637 23 10.9512 23C4.89842 23 0 18.0705 0 12C0 5.92948 4.89842 1 10.9512 1C12.6637 1 14.2869 1.39553 15.7328 2.10137C16.2291 2.34365 16.435 2.9424 16.1927 3.4387C15.9504 3.935 15.3517 4.14092 14.8554 3.89863C13.6765 3.32316 12.3528 3 10.9512 3Z' />
  </svg>
)
const IcoMenu = () => (
  <svg {...svgProps}>
    <path d='M0 4C0 2.89543 0.89543 2 2 2H22C23.1046 2 24 2.89543 24 4C24 5.10457 23.1046 6 22 6H2C0.895431 6 0 5.10457 0 4ZM0 12C0 10.8954 0.89543 10 2 10H22C23.1046 10 24 10.8954 24 12C24 13.1046 23.1046 14 22 14H2C0.895431 14 0 13.1046 0 12ZM24 20C24 18.8954 23.1046 18 22 18H2C0.895431 18 0 18.8954 0 20C0 21.1046 0.89543 22 2 22H22C23.1046 22 24 21.1046 24 20Z' />
  </svg>
)
const IcoMore = () => (
  <svg {...svgProps}>
    <path d='M12 4C10.8954 4 10 3.10457 10 2C10 0.89543 10.8954 -4.82814e-08 12 0C13.1046 4.82832e-08 14 0.895431 14 2C14 3.10457 13.1046 4 12 4Z' />
    <path d='M12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14Z' />
    <path d='M12 24C10.8954 24 10 23.1046 10 22C10 20.8954 10.8954 20 12 20C13.1046 20 14 20.8954 14 22C14 23.1046 13.1046 24 12 24Z' />
  </svg>
)
// remake
const IcoNotification = () => (
  <svg {...svgProps}>
    <path d='M18 16v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-5 0h-2v-2h2v2zm0-4h-2V8h2v4zm-1 10c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2z' />
  </svg>
)
const IcoSplash = () => (
  <svg {...svgProps}>
    <rect x='13' y='12' width='7' height='2' rx='1' />
    <rect x='8' y='9' width='7' height='7' rx='3.5' />
    <rect x='1' y='17' width='6' height='6' rx='3' />
    <rect x='20' width='4' height='4' rx='2' />
    <rect x='17' y='11' width='4' height='4' rx='2' />
    <rect x='17' y='18' width='5' height='5' rx='2.5' />
    <rect y='1' width='6' height='6' rx='3' />
    <rect x='14.4238' y='8.35547' width='8.98825' height='2' rx='1' transform='rotate(-45 14.4238 8.35547)' />
    <rect x='2.26855' y='20.6011' width='12.2651' height='2' rx='1' transform='rotate(-45 2.26855 20.6011)' />
    <rect
      width='6.87291'
      height='2'
      rx='1'
      transform='matrix(-0.707107 -0.707107 -0.707107 0.707107 17.6606 17.2461)'
    />
    <rect width='10.4824' height='2' rx='1' transform='matrix(-0.707107 -0.707107 -0.707107 0.707107 11.291 10.877)' />
  </svg>
)
// remake
const IcoSearch = () => (
  <svg {...svgProps}>
    <path d='M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' />
  </svg>
)
const IcoSettings = () => (
  <svg {...svgProps}>
    <path d='M23.6653 13.0188L21.8245 13.5447C21.6581 13.5934 21.5329 13.7313 21.5004 13.9016V13.9016C21.4187 14.308 21.3106 14.7086 21.1769 15.1009C21.1194 15.2649 21.1589 15.4472 21.2791 15.5727L22.6119 16.9501C22.7553 17.0983 22.7831 17.3237 22.68 17.5023L22.1054 18.4976C22.0023 18.6763 21.7932 18.7649 21.5931 18.7147L19.7238 18.2467H19.7238C19.5555 18.2055 19.3782 18.2621 19.2648 18.3931C18.9932 18.7021 18.7025 18.9937 18.3942 19.2662C18.2632 19.3795 18.2066 19.5567 18.2477 19.725L18.7151 21.5927C18.7652 21.7927 18.6767 22.0018 18.4981 22.105L17.5026 22.6796C17.324 22.7828 17.0986 22.755 16.9504 22.6115L15.5661 21.2722C15.4407 21.152 15.2584 21.1123 15.0944 21.1697C14.7047 21.3032 14.3068 21.4115 13.9032 21.4938C13.7331 21.5265 13.5955 21.6515 13.5467 21.8177L13.0191 23.6649C12.9623 23.8633 12.781 24 12.5748 24H11.4255C11.2192 24 11.0379 23.8633 10.9812 23.6649L10.4538 21.8182C10.4051 21.6517 10.2672 21.5265 10.0968 21.494H10.0968C9.69229 21.4127 9.29343 21.3053 8.90275 21.1726C8.73889 21.1153 8.55676 21.1549 8.43146 21.2751L7.05009 22.6115C6.90186 22.755 6.67645 22.7828 6.49781 22.6796L5.50253 22.105C5.32399 22.0018 5.23547 21.7928 5.2856 21.5927L5.75393 19.7224C5.79515 19.5538 5.73843 19.3763 5.60707 19.2629H5.60707C5.29758 18.9918 5.00554 18.7014 4.73271 18.3935C4.61933 18.2628 4.44242 18.2064 4.27435 18.2475L2.40767 18.7148C2.20756 18.7649 1.99849 18.6763 1.89535 18.4976L1.32035 17.5023C1.21722 17.3237 1.245 17.0983 1.38843 16.9501L2.72396 15.5701C2.84428 15.4445 2.88383 15.262 2.82628 15.098V15.098C2.69184 14.7066 2.58287 14.3069 2.50006 13.9015C2.46745 13.7313 2.34243 13.5937 2.1762 13.545L0.335037 13.0189C0.136668 12.9622 -7.65847e-05 12.7809 3.21794e-08 12.5746V11.4253V11.4253C-7.12197e-05 11.219 0.136678 11.0377 0.335048 10.9811L2.17584 10.4549C2.34228 10.4061 2.4674 10.2683 2.49984 10.0979V10.0979C2.58171 9.69156 2.68983 9.29097 2.82353 8.89862C2.88098 8.73467 2.84143 8.55234 2.7212 8.42693L1.38842 7.04978C1.245 6.90154 1.21722 6.67618 1.32035 6.49754L1.89493 5.50223C1.99814 5.32368 2.2072 5.23516 2.40724 5.2853L4.27683 5.75335C4.4452 5.79451 4.62243 5.73796 4.73584 5.60691L4.73584 5.60691C5.00737 5.29785 5.29812 5.00624 5.60637 4.73381C5.7374 4.6205 5.79396 4.44335 5.75282 4.27508L5.28518 2.40736C5.235 2.20731 5.32353 1.99824 5.5021 1.89505L6.49739 1.32043C6.67603 1.21728 6.9014 1.24504 7.04967 1.38846L8.43399 2.72785C8.55942 2.84807 8.74174 2.88767 8.90574 2.83031L8.90574 2.83031C9.29541 2.69687 9.69325 2.58862 10.0968 2.50622C10.2669 2.47359 10.4045 2.34855 10.4533 2.18231L10.981 0.335079C11.0378 0.13675 11.219 2.26156e-05 11.4253 0H12.5746C12.7809 3.83018e-05 12.9621 0.136759 13.0189 0.335079L13.5465 2.18189C13.5952 2.34839 13.7331 2.47358 13.9035 2.50608V2.50608C14.308 2.58738 14.7069 2.69475 15.0976 2.8275C15.2615 2.88465 15.4435 2.84505 15.5689 2.72499L16.9502 1.38855C17.0984 1.24506 17.3238 1.21726 17.5024 1.32042L18.4977 1.89504C18.6763 1.99822 18.7648 2.20731 18.7146 2.40736L18.2464 4.27771C18.2052 4.44628 18.2619 4.62373 18.3933 4.73713C18.7027 5.00824 18.9947 5.29863 19.2676 5.60658C19.3809 5.73729 19.5578 5.79365 19.7259 5.75257L21.5927 5.2853C21.7927 5.23511 22.0018 5.32364 22.105 5.50223L22.6795 6.49754C22.7827 6.67616 22.7549 6.90154 22.6115 7.04978L21.276 8.43002C21.1557 8.55554 21.1161 8.73802 21.1737 8.90208C21.3081 9.29348 21.4171 9.69316 21.4998 10.0986C21.5325 10.2687 21.6575 10.4063 21.8237 10.455L23.6649 10.9812C23.8633 11.0379 24 11.2192 24 11.4255V12.5747V12.5747C24 12.7808 23.8635 12.962 23.6654 13.0188L23.6653 13.0188ZM7.67641 6.35723C7.61214 6.24537 7.46936 6.20679 7.3575 6.27106C7.34746 6.27683 7.33785 6.28334 7.32877 6.29054H7.32877C4.17559 8.8585 3.7012 13.4964 6.26918 16.6495C6.58543 17.0378 6.94046 17.3929 7.32877 17.7091C7.4299 17.7892 7.57685 17.7722 7.65699 17.6711C7.66416 17.662 7.67065 17.6525 7.67641 17.6425L10.3349 13.0382C10.7059 12.3956 10.7059 11.6039 10.3349 10.9613L7.67641 6.35723ZM12 4.61487C11.1065 4.6139 10.2203 4.7755 9.38469 5.09178C9.26547 5.13902 9.20711 5.27397 9.25436 5.39319C9.25865 5.40403 9.26375 5.41452 9.26963 5.42459L11.9333 10.0382C12.3043 10.6808 12.99 11.0767 13.732 11.0767H19.0517C19.1807 11.0768 19.2854 10.9722 19.2855 10.8432C19.2855 10.8317 19.2847 10.8203 19.283 10.809C18.701 7.23868 15.6175 4.61611 12 4.61487H12ZM19.0515 12.9226H13.7322C12.9902 12.9226 12.3045 13.3185 11.9335 13.9611L9.26986 18.5747C9.20527 18.6855 9.24272 18.8276 9.35351 18.8922C9.36358 18.8981 9.37408 18.9032 9.38492 18.9075H9.38492C13.1994 20.3494 17.4606 18.426 18.9025 14.6115C19.0763 14.1516 19.2038 13.6755 19.283 13.1903C19.3016 13.0626 19.2131 12.944 19.0854 12.9254C19.0743 12.9238 19.063 12.923 19.0517 12.923L19.0515 12.9226Z' />
  </svg>
)
const IcoSettingsMob = () => (
  <svg {...svgProps}>
    <rect x='3' width='2' height='14' rx='1' />
    <rect x='3' y='18' width='2' height='6' rx='1' />
    <rect x='19' y='20' width='2' height='4' rx='1' />
    <rect x='11' y='8' width='2' height='16' rx='1' />
    <rect x='11' width='2' height='4' rx='1' />
    <rect x='8' y='5' width='8' height='4' rx='2' />
    <rect y='15' width='8' height='4' rx='2' />
    <rect x='16' y='15' width='8' height='4' rx='2' />
    <rect x='19' width='2' height='16' rx='1' />
  </svg>
)
const IcoSorting = () => (
  <svg {...svgProps}>
    <path
      fillRule='evenodd'
      d='M22.5 4H10.7439C10.1262 2.25221 8.45933 1 6.5 1C4.54067 1 2.87381 2.25221 2.25606 4H1.5C0.671573 4 0 4.67157 0 5.5C0 6.32843 0.671573 7 1.5 7H2.25606C2.87381 8.74779 4.54067 10 6.5 10C8.45933 10 10.1262 8.74779 10.7439 7H22.5C23.3284 7 24 6.32843 24 5.5C24 4.67157 23.3284 4 22.5 4ZM1.5 17C0.671573 17 0 17.6716 0 18.5C0 19.3284 0.671573 20 1.5 20H13.2561C13.8738 21.7478 15.5407 23 17.5 23C19.4593 23 21.1262 21.7478 21.7439 20H22.5C23.3284 20 24 19.3284 24 18.5C24 17.6716 23.3284 17 22.5 17H21.7439C21.1262 15.2522 19.4593 14 17.5 14C15.5407 14 13.8738 15.2522 13.2561 17H1.5ZM20 18.5C20 19.8807 18.8807 21 17.5 21C16.1193 21 15 19.8807 15 18.5C15 17.1193 16.1193 16 17.5 16C18.8807 16 20 17.1193 20 18.5ZM6.5 8C7.88071 8 9 6.88071 9 5.5C9 4.11929 7.88071 3 6.5 3C5.11929 3 4 4.11929 4 5.5C4 6.88071 5.11929 8 6.5 8Z'
    />
  </svg>
)
const IcoStatistic = () => (
  <svg {...svgProps}>
    <rect x='1' y='22' width='24' height='2' rx='1' />
    <rect x='19' y='12' width='6' height='2' rx='1' />
    <rect x='10' y='12' width='3' height='2' rx='1' />
    <rect x='1' y='12' width='3' height='2' rx='1' />
    <rect x='14.1201' y='12.5283' width='12.416' height='2' rx='1' transform='rotate(-45 14.1201 12.5283)' />
    <rect x='0.583008' y='17.8608' width='15.3723' height='2' rx='1' transform='rotate(-45 0.583008 17.8608)' />
    <rect
      width='7.83407'
      height='2'
      rx='1'
      transform='matrix(-0.707107 -0.707107 -0.707107 0.707107 16.9536 12.5396)'
    />
    <path d='M20 4C20 3.44771 20.4477 3 21 3L24 3C24.5523 3 25 3.44772 25 4C25 4.55229 24.5523 5 24 5L21 5C20.4477 5 20 4.55228 20 4Z' />
    <rect x='23' y='8' width='5' height='2' rx='1' transform='rotate(-90 23 8)' />
  </svg>
)
// remake
const IcoStorage = () => (
  <svg {...svgProps}>
    <path d='M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z' />
  </svg>
)
// remake
const IcoSubject = () => (
  <svg {...svgProps}>
    <path d='M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z' />
  </svg>
)
// remake
const IcoSuccess = () => (
  <svg {...svgProps}>
    <path d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' />
  </svg>
)
const IcoTultip = () => (
  <svg {...svgProps}>
    <path d='M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM13.3563 14.4459C13.4384 14.3655 13.4844 14.2565 13.4844 14.1429C13.4844 13.1804 14.0275 12.5958 14.609 11.9698C15.279 11.2485 16 10.4723 16 9C16 7.34309 14.4331 6 12.5001 6C10.5671 6 9.0002 7.34311 9.0002 9C8.99668 9.32803 9.03911 9.65498 9.12632 9.97171C9.15227 10.0623 9.20778 10.142 9.28437 10.1987C9.36095 10.2554 9.45439 10.286 9.55039 10.2857H10.4388C10.5084 10.2857 10.577 10.2695 10.6388 10.2382C10.7006 10.2069 10.7539 10.1616 10.7942 10.106C10.8344 10.0505 10.8605 9.98625 10.8702 9.91877C10.88 9.85128 10.8731 9.7825 10.8501 9.71817C10.7752 9.48604 10.7398 9.24339 10.7455 9C10.7455 8.28994 11.5723 7.71429 12.418 7.71429C13.2637 7.71429 14.0859 8.28991 14.0859 9C14.0859 9.99075 13.556 10.5562 12.9879 11.1624C12.3319 11.8624 11.625 12.6167 11.625 14.1429C11.625 14.2565 11.6711 14.3655 11.7532 14.4459C11.8352 14.5263 11.9465 14.5714 12.0625 14.5714H13.047C13.163 14.5714 13.2743 14.5263 13.3563 14.4459ZM13.1482 15.9069C12.9564 15.7813 12.7308 15.7143 12.5001 15.7143C12.3469 15.7143 12.1952 15.7438 12.0536 15.8013C11.9121 15.8587 11.7835 15.9429 11.6752 16.049C11.5668 16.1551 11.4809 16.2811 11.4223 16.4198C11.3636 16.5584 11.3335 16.7071 11.3335 16.8571C11.3335 17.0832 11.4019 17.3041 11.5301 17.4921C11.6583 17.68 11.8405 17.8265 12.0536 17.913C12.2668 17.9995 12.5014 18.0221 12.7277 17.978C12.954 17.9339 13.1619 17.8251 13.325 17.6653C13.4882 17.5054 13.5993 17.3018 13.6443 17.0801C13.6893 16.8584 13.6662 16.6286 13.5779 16.4198C13.4896 16.211 13.3401 16.0325 13.1482 15.9069Z' />
  </svg>
)
const IcoUser = () => (
  <svg {...svgProps}>
    <path
      fillRule='evenodd'
      d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
    />
    <path d='M12.0002 5C9.67778 5 8.10531 6.77634 8.10531 9.13463C8.10531 11.874 9.92119 13.5754 12.0002 13.5754C14.0792 13.5754 15.8951 11.874 15.8951 9.13463C15.8951 6.77638 14.3226 5 12.0002 5ZM12.0002 14.8541C9.13732 14.8541 7.1911 15.8444 6.10542 17.1329C5.95451 17.3067 5.96703 17.5671 6.13392 17.7259C9.44622 20.7582 14.5541 20.758 17.8661 17.7254C18.033 17.5666 18.0455 17.3062 17.8945 17.1324C16.8087 15.8439 14.8628 14.8541 12.0002 14.8541Z' />
  </svg>
)
// remake
const IcoWarning = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26 24' width='26' height='24'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.2677 2C12.0375 0.666666 13.962 0.666667 14.7318 2L25.1241 20C25.8939 21.3333 24.9317 23 23.3921 23H2.60747C1.06787 23 0.105625 21.3333 0.875425 20L11.2677 2ZM11.9998 7.99995C11.9998 7.44767 12.4475 6.99995 12.9998 6.99995C13.552 6.99995 13.9998 7.44767 13.9998 7.99995V14C13.9998 14.5522 13.552 15 12.9998 15C12.4475 15 11.9998 14.5522 11.9998 14V7.99995ZM12.9998 19C13.552 19 13.9998 18.5522 13.9998 18C13.9998 17.4477 13.552 17 12.9998 17C12.4475 17 11.9998 17.4477 11.9998 18C11.9998 18.5522 12.4475 19 12.9998 19Z'
    />
  </svg>
)
// remake
const IcoWork = () => (
  <svg {...svgProps}>
    <path d='M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z' />
  </svg>
)
// remake
const IcoWorkOut = () => (
  <svg {...svgProps}>
    <path d='M14 6V4h-4v2h4zM4 8v11h16V8H4zm16-2c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h4V4c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2h4z' />
  </svg>
)

const DayNightSwitch = () => (
  <svg id='toggle' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 34' width='60' height='34'>
    <defs>
      <clipPath id='container'>
        <rect width='60' height='34' rx='17' />
      </clipPath>
      <g id='day'>
        <rect x='0' width='60' height='34' fill='#61b9e5' />
        <g id='day-content'>
          <g className='clouds-small'>
            <path
              d='M13.35,22.45a1,1,0,0,0-.44.1A1.62,1.62,0,0,0,11.29,21a1.67,1.67,0,0,0-.59.11,1.84,1.84,0,0,0-3.55.61h0a1.38,1.38,0,0,0,0,2.75h6.21a1,1,0,1,0,0-2Z'
              transform='translate(-2 -2)'
              fill='#d0edff'
            />
            <path
              d='M27.38,23.72a1.05,1.05,0,0,0-.44.1,1.63,1.63,0,0,0-2.21-1.41,1.84,1.84,0,0,0-3.56.61h0a1.38,1.38,0,1,0,0,2.75h6.21a1,1,0,0,0,0-2.05Z'
              transform='translate(-2 -2)'
              fill='#d0edff'
            />
            <path
              d='M56.7,24a1,1,0,0,0-.44.1,1.63,1.63,0,0,0-2.21-1.42,1.85,1.85,0,0,0-3.56.61h0a1.38,1.38,0,0,0,0,2.75H56.7a1,1,0,0,0,0-2Z'
              transform='translate(-2 -2)'
              fill='#d0edff'
            />
            <path
              d='M84.35,22.45a1,1,0,0,0-.44.1A1.62,1.62,0,0,0,82.29,21a1.67,1.67,0,0,0-.59.11,1.84,1.84,0,0,0-3.55.61h0a1.38,1.38,0,0,0,0,2.75h6.21a1,1,0,1,0,0-2Z'
              transform='translate(-2 -2)'
              fill='#d0edff'
            />
            <path
              d='M98.38,23.72a1.05,1.05,0,0,0-.44.1,1.63,1.63,0,0,0-2.21-1.41,1.84,1.84,0,0,0-3.56.61h0a1.38,1.38,0,1,0,0,2.75h6.21a1,1,0,0,0,0-2.05Z'
              transform='translate(-2 -2)'
              fill='#d0edff'
            />
            <path
              d='M127.7,24a1,1,0,0,0-.44.1,1.63,1.63,0,0,0-2.21-1.42,1.85,1.85,0,0,0-3.56.61h0a1.38,1.38,0,0,0,0,2.75h6.21a1,1,0,0,0,0-2Z'
              transform='translate(-2 -2)'
              fill='#d0edff'
            />
          </g>
          <g className='clouds-medium'>
            <path
              d='M61.44,18.4a1.85,1.85,0,0,0-.77.18,2.85,2.85,0,0,0-2.85-2.68,3,3,0,0,0-1,.19,3.25,3.25,0,0,0-6.26,1.07h0a2.42,2.42,0,0,0,0,4.84H61.44a1.8,1.8,0,1,0,0-3.6Z'
              transform='translate(-2 -2)'
              fill='#e9f8ff'
            />
            <path
              d='M26,17.07a1.84,1.84,0,0,0-.77.17,2.86,2.86,0,0,0-2.85-2.68,2.75,2.75,0,0,0-1,.2,3.24,3.24,0,0,0-6.26,1.07h0a2.42,2.42,0,1,0,0,4.84H26a1.8,1.8,0,0,0,0-3.6Z'
              transform='translate(-2 -2)'
              fill='#e9f8ff'
            />
            <path
              d='M126.44,18.4a1.85,1.85,0,0,0-.77.18,2.85,2.85,0,0,0-2.85-2.68,3,3,0,0,0-1,.19,3.25,3.25,0,0,0-6.26,1.07h0a2.42,2.42,0,0,0,0,4.84h10.92a1.8,1.8,0,1,0,0-3.6Z'
              transform='translate(-2 -2)'
              fill='#e9f8ff'
            />
            <path
              d='M91,17.07a1.84,1.84,0,0,0-.77.17,2.86,2.86,0,0,0-2.85-2.68,2.75,2.75,0,0,0-1,.2,3.24,3.24,0,0,0-6.26,1.07h0a2.42,2.42,0,0,0,0,4.84H91a1.8,1.8,0,0,0,0-3.6Z'
              transform='translate(-2 -2)'
              fill='#e9f8ff'
            />
          </g>
          <g className='clouds-big'>
            <path
              d='M24.82,10.83a3.09,3.09,0,0,0-1.29.29A4.78,4.78,0,0,0,17,7,5.43,5.43,0,0,0,6.54,8.76h0a4,4,0,1,0,0,8.09H24.82a3,3,0,0,0,0-6Z'
              transform='translate(-2 -2)'
              fill='#fff'
            />
            <path
              d='M53.6,9.45a2.37,2.37,0,0,0-1,.24,3.86,3.86,0,0,0-3.84-3.61,4.09,4.09,0,0,0-1.4.26,4.36,4.36,0,0,0-8.41,1.45h0a3.25,3.25,0,0,0,0,6.5H53.6a2.42,2.42,0,1,0,0-4.84Z'
              transform='translate(-2 -2)'
              fill='#fff'
            />
            <path
              d='M98.72,10.83a3.09,3.09,0,0,0-1.29.29A4.78,4.78,0,0,0,90.91,7a5.43,5.43,0,0,0-10.47,1.8h0a4,4,0,1,0,0,8.09H98.72a3,3,0,1,0,0-6Z'
              transform='translate(-2 -2)'
              fill='#fff'
            />
            <path
              d='M127.5,9.45a2.41,2.41,0,0,0-1,.24,3.85,3.85,0,0,0-3.84-3.61,4.09,4.09,0,0,0-1.4.26,4.36,4.36,0,0,0-8.41,1.45h0a3.25,3.25,0,0,0,0,6.5h14.7a2.42,2.42,0,0,0,0-4.84Z'
              transform='translate(-2 -2)'
              fill='#fff'
            />
          </g>
        </g>
      </g>
      <g id='night'>
        <rect width='60' height='34' fill='#004373' />

        <g id='night-content'>
          <polygon
            className='star'
            points='46 4.89 46.62 6.14 48.01 6.35 47.01 7.33 47.24 8.71 46 8.06 44.76 8.71 44.99 7.33 43.99 6.35 45.38 6.14 46 4.89'
            fill='#fff5a6'
          />
          <polygon
            className='star'
            points='58.58 21.93 59.46 23.02 60.86 22.91 60.1 24.09 60.63 25.39 59.28 25.02 58.21 25.94 58.14 24.54 56.94 23.8 58.25 23.3 58.58 21.93'
            fill='#fff5a6'
          />
          <polygon
            className='star'
            points='40.71 12.02 40.82 13.42 42.03 14.13 40.74 14.66 40.44 16.04 39.53 14.97 38.13 15.11 38.87 13.91 38.3 12.63 39.67 12.96 40.71 12.02'
            fill='#fff5a6'
          />
          <polygon
            className='star'
            points='5 16.89 5.62 18.14 7.01 18.35 6 19.33 6.24 20.71 5 20.06 3.76 20.71 4 19.33 2.99 18.35 4.38 18.14 5 16.89'
            fill='#fff5a6'
          />
          <polygon
            className='star'
            points='60.57 6.97 60.79 8.36 62.05 8.97 60.8 9.6 60.61 10.99 59.62 10 58.24 10.25 58.88 9 58.22 7.76 59.6 7.99 60.57 6.97'
            fill='#fff5a6'
          />
          <polygon
            className='star'
            points='30.91 26.12 30.86 27.52 31.98 28.36 30.63 28.74 30.18 30.07 29.4 28.91 28 28.89 28.86 27.78 28.45 26.44 29.77 26.93 30.91 26.12'
            fill='#fff5a6'
          />
          <polygon
            className='star'
            points='17.52 13.95 18.44 15.01 19.83 14.86 19.11 16.06 19.68 17.34 18.32 17.02 17.28 17.96 17.16 16.56 15.94 15.87 17.23 15.32 17.52 13.95'
            fill='#fff5a6'
          />
          <polygon
            className='star'
            points='60.53 16.01 61.11 16.41 61.76 16.15 61.56 16.83 62 17.37 61.3 17.39 60.92 17.98 60.69 17.32 60.01 17.14 60.56 16.71 60.53 16.01'
            fill='#fff5a6'
          />
          <polygon
            className='star'
            points='41.99 21.89 42.31 22.52 43 22.62 42.5 23.11 42.62 23.8 41.99 23.47 41.37 23.8 41.49 23.11 40.99 22.62 41.69 22.52 41.99 21.89'
            fill='#fff5a6'
          />
          <polygon
            className='star'
            points='63.47 26.02 63.43 26.72 63.98 27.15 63.3 27.32 63.05 27.98 62.68 27.39 61.98 27.36 62.43 26.82 62.24 26.14 62.89 26.4 63.47 26.02'
            fill='#fff5a6'
          />
          <polygon
            className='star'
            points='36.99 9.89 37.31 10.52 38 10.62 37.5 11.11 37.62 11.8 36.99 11.47 36.37 11.8 36.49 11.11 35.99 10.62 36.69 10.52 36.99 9.89'
            fill='#fff5a6'
          />
          <polygon
            className='star'
            points='28.5 4.89 28.65 5.2 29 5.25 28.75 5.5 28.81 5.85 28.5 5.68 28.18 5.85 28.24 5.5 27.99 5.25 28.34 5.2 28.5 4.89'
            fill='#fff5a6'
          />
          <polygon
            className='star'
            points='28.5 12.89 28.65 13.2 29 13.25 28.75 13.5 28.81 13.85 28.5 13.68 28.18 13.85 28.24 13.5 27.99 13.25 28.34 13.2 28.5 12.89'
            fill='#fff5a6'
          />
          <polygon
            className='star'
            points='47.75 22.96 47.72 23.31 47.98 23.54 47.64 23.61 47.5 23.94 47.32 23.63 46.97 23.6 47.21 23.34 47.13 23 47.45 23.14 47.75 22.96'
            fill='#fff5a6'
          />
          <polygon
            className='star'
            points='51.75 31.96 51.72 32.31 51.98 32.54 51.64 32.62 51.5 32.94 51.32 32.63 50.97 32.6 51.21 32.34 51.13 32 51.45 32.15 51.75 31.96'
            fill='#fff5a6'
          />
          <polygon
            className='star'
            points='44.69 29.93 44.7 30.28 45 30.47 44.67 30.59 44.58 30.93 44.37 30.66 44.01 30.68 44.21 30.38 44.08 30.06 44.42 30.15 44.69 29.93'
            fill='#fff5a6'
          />
          <polygon
            className='star'
            points='24.32 10.92 24.58 11.16 24.92 11.07 24.78 11.4 24.96 11.7 24.61 11.66 24.39 11.93 24.31 11.58 23.98 11.45 24.29 11.27 24.32 10.92'
            fill='#fff5a6'
          />
          <polygon
            className='star'
            points='24.94 13.18 24.71 13.45 24.79 13.79 24.47 13.65 24.17 13.84 24.2 13.49 23.93 13.26 24.27 13.19 24.41 12.86 24.59 13.16 24.94 13.18'
            fill='#fff5a6'
          />
          <polygon
            className='star'
            points='32 19.89 32.31 20.52 33 20.62 32.5 21.11 32.62 21.8 32 21.47 31.37 21.8 31.49 21.11 30.99 20.62 31.68 20.52 32 19.89'
            fill='#fff5a6'
          />
          <polygon
            className='star'
            points='19.61 21.97 20.15 22.42 20.82 22.23 20.56 22.88 20.95 23.46 20.25 23.42 19.82 23.97 19.64 23.29 18.98 23.04 19.58 22.67 19.61 21.97'
            fill='#fff5a6'
          />
          <polygon
            className='star'
            points='9.51 8.04 9.43 8.74 9.96 9.2 9.28 9.34 9 9.98 8.65 9.37 7.96 9.31 8.43 8.79 8.27 8.11 8.91 8.4 9.51 8.04'
            fill='#fff5a6'
          />
        </g>
      </g>
      <clipPath id='switch'>
        <circle id='circle' cx='19' cy='17' r='10' />
      </clipPath>
    </defs>

    <g clip-path='url(#container)'>
      <use id='back' href='#day' />
      <g clip-path='url(#switch)'>
        <use id='front' href='#night' />
      </g>
      <rect className='inner-shadow' width='70' height='44' rx='20' />
    </g>

    <rect width='60' height='44' rx='17' opacity='0' />
  </svg>
)

const iconArray: { [key: string]: JSX.Element } = {
  add_o: <IcoAddOut />,
  arrows: <IcoArrows />,
  arr_down: <IcoArrDown />,
  apartment: <IcoApartment />,
  backup: <IcoBackUp />,
  close: <IcoClose />,
  check: <IcoCheck />,
  description: <IcoDescription />,
  document: <IcoDocument />,
  error: <IcoError />,
  folder_o: <IcoFolderOut />,
  key: <IcoKey />,
  languages: <IcoLanguages />,
  logout: <IcoLogout />,
  menu: <IcoMenu />,
  more: <IcoMore />,
  info: <IcoNotification />,
  search: <IcoSearch />,
  settings: <IcoSettings />,
  settings_mob: <IcoSettingsMob />,
  sorting: <IcoSorting />,
  splash: <IcoSplash />,
  storage: <IcoStorage />,
  statistic: <IcoStatistic />,
  subject: <IcoSubject />,
  success: <IcoSuccess />,
  tultip: <IcoTultip />,
  user: <IcoUser />,
  warning: <IcoWarning />,
  work: <IcoWork />,
  work_out: <IcoWorkOut />,
}
export default iconArray
